export default __webpack_public_path__ + "static/media/img-0025.1fd7356e.png";